import React, { Component } from 'react';

const renderText = (text) =>{
  if(text){
    return(
      <div className="dm-spinner-text">
        {text}
      </div>
    )
  }
}

const Spinner = ({color, text}) => {


  return (
    <div className="dm-spinner-overlay center-flex flex-item animated fadeIn">
      {renderText(text)}
      <i className="fa fa-spin fa-spinner fa-3x" style={{ color: color || '#31cce5' }}></i>
    </div>
  );
}
export { Spinner };



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js